const marketing = {
  meta: {
    title: "TGReposter — ИИ-платформа для работы с контентом Telegram",
    description: "Собирайте, фильтруйте, улучшайте, проверяйте и публикуйте контент Telegram из одного приватного рабочего пространства.",
  },
  accessibility: {
    home: "Главная TGReposter",
    mainNavigation: "Основная навигация",
    mobileNavigation: "Мобильная навигация",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    flowImage: "Абстрактный поток контента через ИИ-обработку к направлениям Telegram",
  },
  nav: {
    salesPlan: "Тарифы",
    workflow: "Как это работает",
    capabilities: "Возможности",
    security: "Безопасность",
    demo: "Запросить демо",
    dashboard: "Открыть панель",
  },
  hero: {
    badge: "ИИ-управление контентом Telegram",
    title: "Превратите шум Telegram в сигнал для публикации.",
    body: "Следите за важными каналами, улучшайте посты с помощью ИИ и публикуйте одобренный контент во все нужные Telegram-каналы и группы из одного приватного пространства.",
    primary: "Запросить демо-доступ",
    secondary: "Посмотреть процесс",
    humanApproved: "Публикация только после проверки",
    isolated: "Изолированные пространства пользователей",
    stack: "Работает с вашим стеком",
  },
  workflow: {
    eyebrow: "Единый непрерывный процесс",
    title: "От канала-источника до опубликованного поста.",
    body: "TGReposter объединяет сбор, фильтрацию, ИИ-обработку, редакционную проверку и доставку в один прозрачный процесс, сохраняя решение о публикации за человеком.",
    collect: { title: "Сбор", copy: "Следите за публичными Telegram-каналами, которые важны именно вам." },
    filter: { title: "Фильтрация", copy: "Сохраняйте полезные посты и убирайте шум с помощью собственных правил." },
    refine: { title: "Обработка", copy: "Переписывайте, сокращайте, переводите и создавайте хэштеги с помощью ИИ." },
    publish: { title: "Публикация", copy: "Проверьте один раз и отправьте в одно или несколько Telegram-направлений." },
  },
  inbox: {
    title: "Входящий контент",
    status: "Готово к проверке",
    matched: "12 совпадений",
    now: "Сейчас",
    first: { title: "Обновление инфраструктуры ИИ", action: "Новости" },
    second: { title: "Релиз модели с открытым кодом", action: "Перевод" },
    third: { title: "Отчёт об экосистеме Telegram", action: "Сводка" },
  },
  capabilities: {
    eyebrow: "Ваш редакционный центр",
    title: "Автоматизация там, где она помогает. Решение человека там, где это важно.",
    body: "Используйте ИИ, чтобы работать быстрее, не теряя контроль над стилем и смыслом. Каждый пост можно отредактировать и проверить перед публикацией.",
    items: {
      privateInbox: "Приватный контент-инбокс для каждого пользователя",
      aiProviders: "Поддержка Gemini и OpenRouter",
      humanReview: "Ручная проверка перед публикацией",
      multiDestination: "Параллельная отправка в несколько направлений",
      campaigns: "Кампании для каналов, групп и супергрупп",
      roles: "Ролевой доступ для команды",
    },
  },
  cards: {
    curation: {
      eyebrow: "Кураторство контента",
      title: "Соберите сфокусированную ленту из отслеживаемых каналов.",
      body: "Собирайте подходящие посты, исключайте нежелательную рекламу, улучшайте текст и публикуйте только то, что действительно заслуживает внимания.",
    },
    campaign: {
      eyebrow: "Распространение кампаний",
      title: "Распространяйте одно одобренное сообщение по всей сети Telegram.",
      body: "Координируйте отправку в каналы, группы и супергруппы, сохраняя независимый результат для каждого направления.",
    },
  },
  security: {
    eyebrow: "Приватность по умолчанию",
    title: "Ваше рабочее пространство принадлежит только вам.",
    body: "Источники, фильтры, входящие посты, направления, кампании и настройки ИИ изолированы для каждого пользователя. Конфиденциальные данные остаются на сервере и защищены аутентификацией и ролевым доступом.",
  },
  salesPlan: {
    "eyebrow": "Тарифы · Планируемые цены",
    "title": "Одна платформа. Тариф для любого масштаба Telegram.",
    "intro": "Начните с отбора контента и расширяйте работу до многоканальных публикаций, кампаний и команды.",
    "billingLabel": "Период оплаты",
    "periods": {
      "monthly": "Ежемесячно",
      "annual": "Ежегодно"
    },
    "notice": "Предварительные утверждённые цены и планируемые лимиты. Подписка, оплата и покупка ИИ-единиц пока недоступны. Запросите демо для обсуждения тарифа.",
    "popular": "Популярный",
    "custom": "По запросу",
    "perMonth": "/ мес.",
    "enterpriseBilling": "Индивидуальный договор",
    "freeForever": "Бесплатно навсегда",
    "monthlyCharge": "Оплата каждый месяц",
    "annualCharge": "Оплата {{price}} за год",
    "plannedLimits": "Планируемые лимиты",
    "metrics": {
      "users": "Участники команды",
      "sources": "Источники мониторинга",
      "destinations": "Направления публикации",
      "campaigns": "Активные кампании",
      "ai": "ИИ-единицы / мес.",
      "history": "История публикаций"
    },
    "history": {
      "days7": "7 дней",
      "days90": "90 дней",
      "year1": "1 год",
      "year2": "2 года",
      "year3": "3 года",
      "custom": "По запросу"
    },
    "request": "Запросить доступ",
    "contact": "Связаться с командой",
    "discussPlan": "Обсудить тариф {{plan}}",
    "annualSavings": "Годовая оплата экономит до 17% — примерно два месяца бесплатно.",
    "plans": {
      "free": {
        "name": "Free",
        "audience": "Для знакомства",
        "description": "Попробуйте основной процесс с небольшим числом каналов."
      },
      "creator": {
        "name": "Creator",
        "audience": "Авторы",
        "description": "Тратьте меньше времени на подбор и публикацию контента."
      },
      "professional": {
        "name": "Professional",
        "audience": "Несколько каналов",
        "description": "Мониторинг, публикации и продвижение в одном месте."
      },
      "business": {
        "name": "Business",
        "audience": "Медиакоманды",
        "description": "Развивайте контентные процессы с участием команды."
      },
      "agency": {
        "name": "Agency",
        "audience": "Сети каналов",
        "description": "Координируйте крупные сети публикаций и кампании."
      },
      "enterprise": {
        "name": "Enterprise",
        "audience": "Организации",
        "description": "Обсудите индивидуальные лимиты, безопасность и поддержку."
      }
    },
    "topUps": {
      "eyebrow": "Дополнительные ИИ-единицы",
      "title": "Добавляйте ИИ-единицы по необходимости.",
      "description": "Запланированные разовые пакеты дополняют ежемесячный лимит тарифа.",
      "units": "{{units}} ИИ-единиц",
      "note": "ИИ-единицы учитывают расход модели, а не фиксированное число действий. Покупка пакетов и коммерческий учёт ИИ пока не работают.",
      "packs": {
        "mini": "AI Mini",
        "plus": "AI Plus",
        "pro": "AI Pro",
        "max": "AI Max"
      }
    }
  },
  cta: {
    eyebrow: "Посмотрите в своём рабочем процессе",
    title: "Запросите демо-доступ.",
    body: "Расскажите немного о вашей работе в Telegram. Мы рассмотрим сценарий использования и отправим подходящие данные для демо-доступа.",
    button: "Запросить демо",
    points: {
      tailored: "Демонстрация с учётом вашего сценария: кураторство контента, кампании или оба направления",
      private: "Запрос обрабатывается конфиденциально командой TGReposter",
      human: "Без автоматической регистрации — демо-доступ выдаётся после рассмотрения запроса",
    },
  },
  demoForm: {
    eyebrow: "Демо-доступ",
    title: "Расскажите, где TGReposter должен помочь.",
    fullName: "Ваше имя",
    fullNamePlaceholder: "Анна Иванова",
    email: "Email",
    emailPlaceholder: "anna@company.com",
    company: "Компания / команда (необязательно)",
    companyPlaceholder: "Ваша организация",
    telegram: "Имя пользователя Telegram (необязательно)",
    telegramPlaceholder: "@username",
    useCase: "Для чего вы хотите использовать TGReposter?",
    useCases: {
      curation: "Кураторство контента и репостинг",
      campaigns: "Промокампании",
      both: "Кураторство и кампании",
      other: "Другой сценарий",
    },
    message: "Что вы хотите увидеть на демо? (необязательно)",
    messagePlaceholder: "Расскажите о каналах, рабочем процессе или задаче, которую хотите решить.",
    submit: "Запросить демо-доступ",
    submitting: "Отправляем запрос…",
    privacy: "Мы используем эти данные только для рассмотрения запроса и связи с вами по поводу TGReposter.",
    successTitle: "Запрос получен.",
    successBody: "Спасибо. Мы рассмотрим ваш сценарий и свяжемся с вами по следующему шагу для получения демо-доступа.",
    submitAnother: "Отправить ещё один запрос",
    error: "Не удалось отправить запрос. Проверьте подключение и попробуйте ещё раз.",
  },
  footer: {
    salesPlan: "Тарифы",
    workflow: "Процесс",
    capabilities: "Возможности",
    security: "Безопасность",
    demo: "Запросить демо",
    dashboard: "Панель",
  },
} as const;

export default marketing;
